/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Checkyouremail2Inputs */

const en_auth_checkyouremail2 = /** @type {(inputs: Auth_Checkyouremail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Auth_Checkyouremail2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_checkyouremail2 = /** @type {((inputs?: Auth_Checkyouremail2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Checkyouremail2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_checkyouremail2(inputs)
});
export { auth_checkyouremail2 as "auth_checkYourEmail" }